<template>
  <span>
    <span :class="['label', `label-order-status-${status}`]" v-if="status">{{status | formatLookupName(OrderStatusTypeLookup)}}</span>
    <span :class="['label', holdClass, `ml-1`]" v-if="isOnHold"><i class="far fa-fw fa-pause-circle"></i> Hold{{holdTypeTitle}}</span>
    <span :class="['label', `label-order-urgent`, `ml-1`]" v-if="isUrgent"><i class="far fa-fw fa-exclamation"></i> Urgent</span>
    <span :class="['label', `label-order-partial-invoiced`, `ml-1`]" v-if="displayPartialInvoiced"><i class="far fa-fw fa-envelope-open-dollar"></i> Partially Invoiced</span>
    <span :class="['label', `label-order-invoiced`, `ml-1`]" v-if="displayInvoicingComplete"><i class="far fa-fw fa-envelope-open-dollar"></i> Invoiced</span>
    <span :class="['label', `label-order-tasks-assigned`, `ml-1`]" v-if="isActiveTasksAssigned"><i class="far fa-fw fa-calendar-check"></i> Tasks Assigned</span>
  </span>
</template>

<script>
import { OrderStatusTypes, OrderStatusTypeLookup, OrderHoldTypes, OrderHoldTypeLookup } from '@/store/types'

export default {
  name: 'LabelOrderStatusBadge',
  props: {
    status: String,
    isOnHold: Boolean,
    holdType: String,
    isUrgent: Boolean,
    isActiveTasksAssigned: Boolean,
    isInvoiced: Boolean,
    isInvoicingComplete: Boolean
  },
  created() {
    this.OrderStatusTypeLookup = OrderStatusTypeLookup
  },
  computed: {
    holdClass() {
      if(!this.holdType)
        return 'label-order-hold'

      return `label-order-hold-${this.holdType}`
    },
    holdTypeTitle() {
      if(!this.holdType)
        return ''

      return ' : ' + this.formatLookupName(this.holdType, OrderHoldTypeLookup)
    },
    isStatusCompleted() {
      return this.status == OrderStatusTypes.completed
    },
    isStatusCancelled() {
      return this.status == OrderStatusTypes.cancelled
    },
    displayPartialInvoiced() {
      if(this.isStatusCompleted || this.isStatusCancelled)
        return false

      return this.isInvoiced && !this.isInvoicingComplete
    },
    displayInvoicingComplete() {
      if(this.isStatusCompleted || this.isStatusCancelled)
        return false

      return this.isInvoicingComplete
    }
  }
}
</script>
